import React, { Component } from 'react';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const MySlider = () => {
  return class extends Component {
    render(){
      return <Slider {...this.props} />
    }
  }
}

export default MySlider;


// WEBPACK FOOTER //
// ./src/Views/Components/MySlider.js